// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Core__Option from "@rescript/core/src/Core__Option.mjs";
import * as RelayRouter__Context from "./RelayRouter__Context.mjs";
import * as RelayRouter__Internal from "./RelayRouter__Internal.mjs";

function childRouteHasContent(childRoute) {
  return Caml_obj.notequal(childRoute, null);
}

function useRouter() {
  var match = RelayRouter__Context.useRouterContext();
  var markNextNavigationAsShallow = match.markNextNavigationAsShallow;
  var postRouterEvent = match.postRouterEvent;
  var history = match.history;
  var get = match.get;
  var push = React.useCallback((function (path, shallowOpt) {
          var shallow = shallowOpt !== undefined ? shallowOpt : false;
          if (shallow) {
            markNextNavigationAsShallow();
          }
          postRouterEvent({
                TAG: "OnBeforeNavigation",
                currentLocation: get().location
              });
          history.push(path);
        }), [
        history,
        postRouterEvent
      ]);
  var replace = React.useCallback((function (path, shallowOpt) {
          var shallow = shallowOpt !== undefined ? shallowOpt : false;
          if (shallow) {
            markNextNavigationAsShallow();
          }
          postRouterEvent({
                TAG: "OnBeforeNavigation",
                currentLocation: get().location
              });
          history.replace(path);
        }), [
        history,
        postRouterEvent
      ]);
  return {
          push: push,
          replace: replace,
          preload: match.preload,
          preloadCode: match.preloadCode
        };
}

function useLocation() {
  var router = RelayRouter__Context.useRouterContext();
  var match = React.useState(function () {
        return router.history.location;
      });
  var setLocation = match[1];
  React.useEffect((function () {
          return router.history.listen(function (param) {
                      var $$location = param.location;
                      setLocation(function (param) {
                            return $$location;
                          });
                    });
        }), [router.history]);
  return match[0];
}

function isRouteActive(pathname, routePattern, exactOpt) {
  var exact = exactOpt !== undefined ? exactOpt : false;
  return Core__Option.isSome(RelayRouter__Internal.matchPathWithOptions({
                  path: routePattern,
                  end: exact
                }, pathname));
}

function useIsRouteActive(routePattern, exactOpt) {
  var exact = exactOpt !== undefined ? exactOpt : false;
  var match = useLocation();
  var pathname = match.pathname;
  return React.useMemo((function () {
                return isRouteActive(pathname, routePattern, exact);
              }), [
              pathname,
              routePattern,
              exact
            ]);
}

export {
  childRouteHasContent ,
  useRouter ,
  useLocation ,
  isRouteActive ,
  useIsRouteActive ,
}
/* react Not a pure module */
